<script>
	import { createEventDispatcher } from 'svelte';
	import Contact from '../../States/Contact';
	import Conference from '../../States/Conference';
	import Helper from '../../Models/Helper';

	export let conference = {};
	export let contact = {};
	export let editing = false

	const dispatch = createEventDispatcher();
	let dialpad = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '#'];

	function toggleEdit() {
		editing = !editing
	}

	function save(event) {
		const form = Helper.form(event.target)
		Contact.save(form);
		toggleEdit();
	}

	function hangup() {
		dispatch('hangup');
	}

	function call() {
		dispatch('call');
	}

	function join() {
		dispatch('join');
	}

	function dial(item) {
		Conference.dial(item);
	}
</script>

<style>
	.round-name {
		width: 75px;
		height: 75px;
		font-size: 1.5em;
		justify-self: center;
	}
	#contact-info-header {
		display: grid;
		justify-content: center;
	}
	.dropdown-item, .dropdown-toggle {
		cursor: pointer;
	}

	#dialpad .btn {
		padding: 0.18rem 0.44rem;
		margin-right: 0.25em;
	}

	#digits-pressed {
		margin-top: 1em;
	}

	#digits-pressed span {
		margin-right: .2em;
	}

	#block-switch.form-check-input:checked {
		background-color: var(--bs-red);
		border-color: var(--bs-red);
	}
</style>

<div class="card">
	<div class="card-body">
		<div class="dropdown float-end">
			<div class="dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown" aria-expanded="false">
				<i class="mdi mdi-dots-horizontal"></i>
			</div>
			<div class="dropdown-menu dropdown-menu-end">
				<div class="dropdown-item" on:click={toggleEdit}>Edit</div>
			</div>
		</div>

		<div id="contact-info-header" class="mt-3 text-center">
			<div class="round-name">{contact.initials}</div>
			<h4>{contact.name}</h4>
			{#if conference?.active}
				<button class="btn btn-danger btn-sm mt-1" on:click={hangup}><i class='uil uil-incoming-call me-1'></i>Hangup</button>
			{:else if conference?.showActive}
				<button class="btn btn-success btn-sm mt-1" on:click={join}><i class='uil uil-outgoing-call me-1'></i>Join</button>
			{:else}
				<button class="btn btn-success btn-sm mt-1" on:click={call}><i class='uil uil-outgoing-call me-1'></i>Call</button>
			{/if}
			{#if conference?.active}
				<p class="text-muted mt-2 font-14">Active for: <strong>{conference?.formattedDuration} minutes</strong></p>
			{:else}
				<p class="text-muted mt-2 font-14">Last called: <strong>{contact?.lastCalled ? contact.lastCalled : 'Not Yet'}</strong></p>
			{/if}
		</div>

		{#if conference?.active}
			<div id="dialpad">
				{#each dialpad as item}
					<button class="btn btn-light btn-sm" data-btn="{item}" on:click="{() => dial(item) }">{item}</button>
				{/each}
			</div>

			{#if conference?.dialPressed && conference.dialPressed.length}
				<div id="digits-pressed">
					<b>Digits Pressed:</b>
					{#each conference.dialPressed as dial}
						<span>{dial}</span>
					{/each}
				</div>
			{/if}
		{/if}

		{#if editing}
			<form method="post" on:submit|preventDefault={save}>
				<div class="mt-3">
					<hr class="" />
					<div class="mb-3">
						<label for="name" class="form-label"><strong><i class='uil uil-at'></i> Name:</strong></label>
						<input type="text" id="name" name="name" class="form-control" bind:value="{contact.name}">
					</div>
					<div class="mb-3">
						<label for="mail" class="form-label"><strong><i class='uil uil-at'></i> Email:</strong></label>
						<input type="mail" id="mail" name="mail" class="form-control" bind:value="{contact.mail}">
					</div>

					<div class="mb-3">
						<label for="phone" class="form-label"><strong><i class='uil uil-phone'></i> Phone Number:</strong></label>
						<input type="phone" id="phone" name="phone" class="form-control" bind:value="{contact.phone}">
					</div>

					<div class="mb-3">
						<label for="location" class="form-label"><strong><i class='uil uil-location'></i> Location:</strong></label>
						<input type="text" id="location" name="location" class="form-control" bind:value="{contact.location}">
					</div>

					<div class="mb-3">
						<label for="company" class="form-label"><strong><i class='uil uil-users-alt'></i> Company:</strong></label>
						<input type="text" id="company" name="company" class="form-control" bind:value="{contact.company}">
					</div>

					<div class="form-check form-switch">
						<input type="hidden" name="blocked" value="0">
						<input type="checkbox" class="form-check-input" id="block-switch" name="blocked" bind:checked={contact.blocked} value="{contact.blocked ? 1 : 0}">
						<label class="form-check-label" for="block-switch">Blocked</label>
					</div>

					<div>
						<button type="submit" class="btn btn-primary float-end">Save</button>
					</div>
				</div>
			</form>
		{:else}
			<div class="mt-3">
				<hr class="" />
				{#if contact.mail}
					<p class="mt-4 mb-1"><strong><i class='uil uil-at'></i> Email:</strong></p>
					<p>{contact.mail}</p>
				{/if}

				{#if contact.phone}
					<p class="mt-3 mb-1"><strong><i class='uil uil-phone'></i> Phone Number:</strong></p>
					<p>{contact.phone}</p>
				{/if}

				{#if contact.location}
					<p class="mt-3 mb-1"><strong><i class='uil uil-location'></i> Location:</strong></p>
					<p>{contact.location}</p>
				{/if}

				{#if contact.company}
					<p class="mt-3 mb-2"><strong><i class='uil uil-users-alt'></i> Company:</strong></p>
					<p>
						<span class="badge badge-primary-lighten p-1 font-14">{contact.company}</span>
					</p>
				{/if}

				<div class="form-check form-switch">
					<input type="checkbox" class="form-check-input" id="block-switch" name="blocked" bind:checked={contact.blocked} disabled>
					<input type="hidden" name="blocked" value="0">
					<label class="form-check-label" for="block-switch">Blocked</label>
				</div>
			</div>
		{/if}
	</div>
</div>